export const environment = {
  production: true,
  rollbar: {
    enabled: true,
    code_version: 'edge'
  }
};
